import { useUser } from '../../providers/UserProvider';
import { AdnginEndMobile0 } from '../AdnginEndMobile0';
import { DailyEndActions } from './DailyEndActions';
import { DailyEndSummary } from './DailyEndSummary';

/**
 * The day's wrap-up, shown once the flag and the bonus rounds are behind the
 * player. A screen of its own rather than a panel appended to the last round,
 * so it owns the view and survives a reload without any special handling.
 */
export const DailyEndScreen = () => {
  const { userDetails } = useUser();

  return (
    <div className="flex flex-col w-full max-w-lg px-3 pt-[10px] gap-4 items-center">
      <DailyEndSummary />
      <DailyEndActions />
      {!userDetails?.premiumGames?.includes('flagle') && <AdnginEndMobile0 />}
    </div>
  );
};
